<template>

  <t-page>

    <b-modal size="lg" v-model="modalFields" id="modal-fields-activity-child"
             hide-footer
             title="Editar campos customizados do formulário interno dos itens">
      <PageField v-if="modalFields" name="Campos internos" :foreign-key="typeChecklistActivity.activityChildPageId" />
    </b-modal>

    <b-modal size="lg" v-model="modalView" id="modal-view-activity-child" hide-footer
             title="Editar visualização do formulário interno dos itens">
      <PageView v-if="modalView" name="Campos internos" :foreign-key="typeChecklistActivity.activityChildPageId"/>
    </b-modal>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #right-buttons-add-items>

        <b-dropdown-item @click="modalFields = true"
                         v-if="pageListIsLoaded && relationAccessSubValidation('sub-action-general-edit-field') && typeChecklistActivity.enableChild">
          Editar campos dos itens
        </b-dropdown-item>

        <b-dropdown-item @click="modalView = true"
                         v-if="pageListIsLoaded && relationAccessSubValidation('sub-action-general-edit-view') && typeChecklistActivity.enableChild">
          Editar visualização dos itens
        </b-dropdown-item>


      </template>

      <template #search>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         big-search
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-code-label enterprise
                              v-model="form.enterpriseId"/>

          <div class="alert-warning p-1 pb-0 mb-2" v-if="getRenderRule('sub-checklist-activity-enable-edit-all-users')">
            <t-input-code-label inspector
                                v-model="form.inspectorId"/>
            <small>Habilitado, pois você possui acesso a listagem completa</small>

          </div>

          <t-input-search v-model="form.issueDate" enable-range date label="Data Preenchido"/>

        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               :primary-key-column="'activity'+activityNumber+'Number'"
               :link-primary-column="'activity'+activityNumber+'Number'"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import PageField from "@/views/modules/general/PageField";
import PageView from "@/views/modules/general/PageView";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {PageField, PageView},
  name: 'ChecklistActivityListEmbeddable',
  data() {
    return {
      enableGeneralFields: true,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalFields: false,
      modalView: false,
      typeChecklistActivity: {
        enableChild: false,
        activityChildPageId: 0,
      },
      form: {
        enterpriseId: 0,
        inspectorId: 0,
        issueDate: "",
      },
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    activityNumber: Number,
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Atividades', to: {name: 'checklist-type-activity'}},
      ]

    },
    async mountedContinued() {

      const typeChecklistActivity = this.getRenderRule('typeChecklistActivity')

      if (this.objValid(typeChecklistActivity)) {
        this.typeChecklistActivity = typeChecklistActivity
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

